"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loading = exports.Content = exports.Bg = exports.LoadingContainer = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _styled = _interopRequireDefault(require("../../theme/styled"));

var _basis = require("basis");

var _templateObject, _templateObject2, _templateObject3;

var LoadingContainer = _styled.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  align-self: center;\n"])));

exports.LoadingContainer = LoadingContainer;

var Bg = _styled.default.div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background-color: ", ";\n  opacity: ", ";\n"])), function (p) {
  return p.bgColor;
}, function (p) {
  var _p$bgOpacity;

  return (_p$bgOpacity = p.bgOpacity) !== null && _p$bgOpacity !== void 0 ? _p$bgOpacity : '1';
});

exports.Bg = Bg;

var Content = _styled.default.div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  & > *:last-child {\n    margin-top: ", ";\n  }\n"])), function (p) {
  return p.theme.basis.space[3];
});

exports.Content = Content;

var Loading = function Loading(props) {
  var text = props.text,
      bgColor = props.bgColor,
      bgOpacity = props.bgOpacity;
  return /*#__PURE__*/_react.default.createElement(LoadingContainer, null, bgColor && /*#__PURE__*/_react.default.createElement(Bg, {
    "data-testid": "loading-bg",
    bgColor: bgColor,
    bgOpacity: bgOpacity
  }), /*#__PURE__*/_react.default.createElement(Content, null, /*#__PURE__*/_react.default.createElement(_basis.LoadingIcon, {
    size: "medium",
    testId: "loading-icon"
  }), text && /*#__PURE__*/_react.default.createElement(_basis.Text, {
    textStyle: "heading6"
  }, text)));
};

exports.Loading = Loading;